/** Default tag / measurement color when no user or tag color is set. Matches backend palette index 0. */
export const DEFAULT_TAG_COLOR = "#0EA5E9";
